import React from 'react'

import { Label, RequiredMark } from './styled'

interface RequiredFieldLabelProps {
  children: React.ReactNode
  required?: boolean
  className?: string
}

export const RequiredFieldLabel: React.FC<RequiredFieldLabelProps> = ({
  children,
  required = false,
  className,
}) => (
  <Label className={className}>
    {children}
    {required && <RequiredMark>*</RequiredMark>}
  </Label>
)

export default RequiredFieldLabel
